export var EVENT_LIVE_MESSAGE='event.live_message';export var LIVE_MESSAGE_TYPE_POLITE='polite';export var LIVE_MESSAGE_TYPE_ASSERTIVE='assertive';